import { DataTable } from "@circleco/compass/components/DataTable";
import { useMemo } from "react";

import { createColumns } from "./columns";
import type { MemberEntry, MembersToAddListProps } from "./types";

export const MembersToAddListCompass = ({
  memberIds = [],
  members = [],
  onRemove,
}: MembersToAddListProps) => {
  const hasIds = memberIds.length > 0;

  const data = useMemo<MemberEntry[]>(() => {
    const membersById = new Map(
      members.map(member => [String(member.id), member]),
    );
    return memberIds
      .map(memberId => membersById.get(String(memberId)))
      .filter((member): member is MemberEntry => Boolean(member));
  }, [memberIds, members]);

  const columns = useMemo(() => createColumns(onRemove), [onRemove]);

  if (!hasIds) {
    return null;
  }

  return (
    <div className="mt-4">
      <DataTable<MemberEntry>
        className="max-h-80"
        data={data}
        columns={columns}
        getRowId={row => String(row.id)}
        rowSize="md"
        hideFooterOnSinglePage
        minHeight={0}
      />
    </div>
  );
};
